import { Chart } from '@frontend/chart/types';

/** Duration values are average completed drop-off-pending timer seconds per user. */
export const PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_DROP_OFF_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'User One', data: [{ label: 'full_period', value: 259200 }] },
        { name: 'User Two', data: [{ label: 'full_period', value: 172800 }] },
        { name: 'User Three', data: [{ label: 'full_period', value: 86400 }] },
        { name: 'User Four', data: [{ label: 'full_period', value: 43200 }] },
        { name: 'User Five', data: [{ label: 'full_period', value: 28800 }] },
        { name: 'User Six', data: [{ label: 'full_period', value: 14400 }] },
        { name: 'User Seven', data: [{ label: 'full_period', value: 7200 }] },
        { name: 'User Eight', data: [{ label: 'full_period', value: 3600 }] }
    ]
};
